import React, { useMemo, useState } from 'react'
import { Input, InputCheck, Popup } from 'src/components'
import { useStyles } from './styles'
import { useDebounce } from 'src/hooks/useDebounce'
import { PastureDto } from 'src/dto/pasture.dto'
import { IAnimal } from 'src/dto/animal.dto'

type Animal = NonNullable<PastureDto['animais']>[number] | IAnimal

interface SelectAnimalModalProps {
  animals: Animal[]
  isOpen: boolean
  onClose: () => void
  disableSelected?: boolean
  onClickItem?: (item: Animal) => void
  value: string[]
  onChange: (selected: string[]) => void
}

export const SelectAnimalModal: React.FC<SelectAnimalModalProps> = ({
  animals,
  isOpen,
  onClose,
  value,
  onChange,
  disableSelected,
  onClickItem
}) => {
  const styles = useStyles()

  const [search, setSearch] = useState('')
  const debouncedSearch = useDebounce(search, 400)

  const filteredAnimals = useMemo(() => {
    if (!debouncedSearch) return animals

    const searchValue = debouncedSearch.toLowerCase()

    return animals?.filter((animal) => {
      return animal.nome?.toLowerCase().includes(searchValue) || animal.cdn?.toString().includes(searchValue)
    })
  }, [animals, debouncedSearch])

  const handleSelectAnimal = (id: string) => {
    if (value.includes(id)) {
      onChange(value.filter((item) => item !== id))
    } else {
      onChange([...value, id])
    }
  }

  return (
    <Popup title='Selecionar animais' isOpen={isOpen} onClose={onClose} closeOnClickOutside={false} maxWidth='sm'>
      <div className={styles.selectedAnimalLotModalContent}>
        <div className={styles.inputContainer}>
          <Input
            label='Buscar animal'
            placeholder='Procurar...'
            value={search}
            onChange={(value: string) => setSearch(value)}
          />
        </div>

        {filteredAnimals && filteredAnimals.length > 0 ? (
          filteredAnimals.map((item) => (
            <div
              key={item.idAnimal}
              onClick={() => onClickItem && onClickItem(item)}
              style={{ cursor: onClickItem ? 'pointer' : 'default' }}
            >
              <div className={styles.animalCard}>
                {disableSelected ? null : (
                  <InputCheck
                    label=''
                    id={item.idAnimal!}
                    value={item.idAnimal!}
                    checked={value.includes(item.idAnimal!)}
                    onChange={() => handleSelectAnimal(item.idAnimal!)}
                  />
                )}
                <div className={styles.animalInfo}>
                  <span>{item.nome || 'Sem nome'}</span>
                  <span>Número: {item.cdn || '-'}</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className={styles.noAnimalFound}>
            <span>Nenhum animal encontrado</span>
          </div>
        )}
      </div>
    </Popup>
  )
}
